<div class="rtnav ui-g">
  <div class="ui-g-6 msgbox-6">
    @for (message of msgsPoeSurvey; track message) {
      <p-message [life]="3000" [text]="message.detail"></p-message>
    }
  </div>
  @if (!btnNavPoeSurvey) {
    <div class="ui-g-5"></div>
  }
  @if (btnNavPoeSurvey) {
    <div class="ui-g-5">
      <button
        type="button"
        pButton
        (click)="editPoeSurveyCancel()"
        class="ui-button-secondary flat fl-rt">
        Cancel
      </button>
      <button
        type="submit"
        pButton
        (click)="onSubmitPOESurvey()"
        class="flat btnmr fl-rt">
        Save
      </button>
    </div>
  }
  <div class="ui-g-1 edit-history-icon">
    <span
      class="fa fa-pencil ico cpointer fl-rt"
      pTooltip="Edit"
      (click)="editPoeSurvey()"
      (keyup.enter)="editPoeSurvey()"
      tabindex="0"
      tooltipPosition="bottom"></span>
  </div>
</div>
<form [formGroup]="formPOESurvey">
  <div class="readonlytbox">
    <div class="edittablebdr">
      <table cellpadding="0" cellspacing="0">
        <tr>
          <th style="width: 25%">POE Status</th>
          <th style="width: 25%">POE Document Submitted Date</th>
          <th style="width: 25%">POE Completion Date</th>
          <th style="width: 25%"></th>
        </tr>
        <tr>
          <td>
            <p-select
              appendTo="body"
              [options]="poeStatus"
              panelStyleClass="poe-submission-status-dropdown"
              [readonly]="isReadonlyPOESurvey"
              [class.readonlydd]="isReadonlyPOESurvey === true"
              formControlName="PoeStatus1"
              placeholder="--SELECT--"
              optionLabel="poeStatusName"></p-select>
          </td>
          <td>
            <p-datepicker
              formControlName="poeDocumentSubmittedDate"
              dateFormat="mm/dd/yy"
              [readonlyInput]="true"
              [showOnFocus]="false"
              [showIcon]="isReadonlyPOESurvey === false"
              [iconDisplay]="'input'"
              [class.readonlycaltb]="isReadonlyPOESurvey === true"
              [defaultDate]="maxYearDate">
            </p-datepicker>
          </td>
          <td>
            <p-datepicker
              formControlName="pOECompletionDate"
              dateFormat="mm/dd/yy"
              [readonlyInput]="true"
              [showOnFocus]="false"
              [showIcon]="isReadonlyPOESurvey === false"
              [iconDisplay]="'input'"
              [class.readonlycaltb]="isReadonlyPOESurvey === true"
              [defaultDate]="maxYearDate"></p-datepicker>
          </td>
          <td></td>
        </tr>
      </table>
    </div>
    @if (engagementSurveys && engagementSurveys.length > 0) {
      <div class="edittablebdr">
        <div class="ui-g">
          <div class="ui-g-12 ui-md-12 ui-lg-12">
            <div class="hdbl">Summary</div>
          </div>
        </div>

        <table cellpadding="0" cellspacing="0">
          <thead>
            <tr>
              <th style="width: 10%"></th>
              <th style="width: 5%"></th>
              <th style="width: 10%">Preview</th>
              <th style="width: 10%">Survey Name</th>
              <th style="width: 10%">Type</th>
              <th style="width: 10%">Created Date</th>
              <th style="width: 10%">Survey Date</th>
              <th style="width: 15%">Status</th>
              <th style="width: 20%">Reason</th>
            </tr>
          </thead>
          <tbody>
            <ng-template ngFor let-survey [ngForOf]="engagementSurveys">
              <tr>
                <td>
                  <a
                    class="cpointer"
                    (click)="cusSurveyResponse()"
                    (keyup.enter)="cusSurveyResponse()"
                    tabindex="0"
                    >+ Response</a
                  >
                </td>
                @if (survey.surveyType === 'Customer') {
                  <td>
                    <span
                      class="fa fa-download ico cpointer"
                      pTooltip="Download"
                      (click)="cusSurveyResponseDownload('Customer')"
                      (keydown.enter)="cusSurveyResponseDownload('Customer')"
                      tabindex="0"
                      tooltipPosition="bottom"></span>
                  </td>
                }
                @if (survey.surveyType === 'Partner') {
                  <td>
                    <span
                      class="fa fa-download ico cpointer"
                      pTooltip="Download"
                      (click)="cusSurveyResponseDownload('Partner')"
                      (keydown.enter)="cusSurveyResponseDownload('Partner')"
                      tabindex="0"
                      tooltipPosition="bottom"></span>
                  </td>
                }
                @if (survey.surveyType === 'Customer') {
                  <td class="colsmall">
                    <span
                      tooltipPosition="top"
                      pTooltip="{{ engagementId }} : {{ engagementId }}"
                      ><a
                        class="editlink"
                        (click)="previewCustomerSurvey(engagementId)"
                        (keydown.enter)="previewCustomerSurvey(engagementId)"
                        tabindex="0"
                        >Preview</a
                      ></span
                    >
                  </td>
                }
                @if (survey.surveyType === 'Partner') {
                  <td class="colsmall">
                    <span
                      tooltipPosition="top"
                      pTooltip="{{ engagementId }} : {{ engagementId }}"
                      ><a
                        class="editlink"
                        (click)="previewPartnerSurvey(engagementId)"
                        (keydown.enter)="previewPartnerSurvey(engagementId)"
                        tabindex="0"
                        >Preview</a
                      ></span
                    >
                  </td>
                }
                <td>{{ survey.surveyName }}</td>
                <td>{{ survey.surveyType }}</td>
                <td>{{ null | date: 'MM/dd/yyyy' }}</td>
                <td>
                  <p-datepicker
                    formControlName="customerPOESurveyDate"
                    dateFormat="mm/dd/yy"
                    [readonlyInput]="true"
                    [showOnFocus]="false"
                    [showIcon]="isReadonlyPOESurvey === false"
                    [iconDisplay]="'input'"
                    [class.readonlycaltb]="isReadonlyPOESurvey === true"
                    [defaultDate]="maxYearDate">
                  </p-datepicker>
                </td>
                @if (survey.surveyType === 'Partner') {
                  <td>
                    <p-select
                      appendTo="body"
                      [disabled]="true"
                      [options]="partnerPOESurveyStatus"
                      [readonly]="isReadonlyPOESurvey"
                      [class.readonlydd]="isReadonlyPOESurvey === true"
                      formControlName="partnerPOESurveyStatus"
                      placeholder="--SELECT--"
                      optionLabel="poeSurveyStatusName"></p-select>
                  </td>
                }
                @if (survey.surveyType === 'Customer') {
                  <td>
                    <p-select
                      appendTo="body"
                      [disabled]="false"
                      [options]="partnerPOESurveyStatus"
                      [readonly]="isReadonlyPOESurvey"
                      [class.readonlydd]="isReadonlyPOESurvey === true"
                      formControlName="customerPOESurveyStatus"
                      placeholder="--SELECT--"
                      optionLabel="poeSurveyStatusName"></p-select>
                  </td>
                }
                <td>
                  <span>
                    @if (
                      formPOESurvey.controls['customerPOESurveyStatus'].value
                        .poeSurveyStatusName === 'Rejected' &&
                      !isReadonlyPOESurvey &&
                      customerPOESurveyRejectionReasons
                    ) {
                      <p-multiSelect
                        appendTo="body"
                        name="customerPoeSurveyRejectionList"
                        placeholder="Select reason for rejecting the invoice"
                        [maxSelectedLabels]="2"
                        [options]="customerPOESurveyRejectionReasons.reason"
                        optionLabel="reason"
                        formControlName="customerPOESurveyRejectionReasonsCtrl"></p-multiSelect>
                    }
                  </span>
                  @if (canShowCustomerSurveyRejection && isReadonlyPOESurvey) {
                    <span>{{ customerSurveyRejectionReason }}</span>
                  }
                </td>
              </tr>
              <tr>
                @if (isCusSurveyResponse) {
                  <td colspan="8" class="bgtd">
                    <table class="reptable" cellpadding="0" cellspacing="0">
                      <tr>
                        <th>Ques#</th>
                        <th>Questions</th>
                        <th>Response</th>
                      </tr>
                      @for (question of survey.responses; track question) {
                        <tr>
                          <td>{{ question.questionSequenceOrder }}</td>
                          <td>{{ question.question }}</td>
                          <td>{{ question.answer }}</td>
                        </tr>
                      }
                    </table>
                  </td>
                }
              </tr>
            </ng-template>
          </tbody>
        </table>
      </div>
    }
    @if (poeNominationRequiredDocuments) {
      <div class="edittablebdr">
        <div class="ui-g">
          <div class="ui-g-12 ui-md-12 ui-lg-12 poe-doc-head">
            <div class="hdbl">Required Documentation</div>
            <div>
              @if (
                (!this.rpfShow && !isDealAssociation) || isOperatorSecurityRFP
              ) {
                <button
                  type="button"
                  pButton
                  (click)="
                    onPoeDocumentUploadClick(DocumentTypesValue.POEInvoice)
                  "
                  pTooltip="Upload or View"
                  tooltipPosition="top"
                  class="ui-button-info btnpad btnmr">
                  Add POE Invoice
                </button>
              }
              @if (!this.rpfShow) {
                <button
                  type="button"
                  pButton
                  (click)="
                    onPoeDocumentUploadClick(DocumentTypesValue.POEDocument)
                  "
                  pTooltip="Upload or View"
                  tooltipPosition="top"
                  class="ui-button-info btnpad btnmr">
                  Add Findings & Recommendation
                </button>
              }
              @if (this.rpfShow) {
                <button
                  type="button"
                  pButton
                  (click)="
                    onPoeDocumentUploadClick(
                      DocumentTypesValue.RequestForProposalAwardLetter
                    )
                  "
                  pTooltip="Upload or View"
                  tooltipPosition="top"
                  class="ui-button-info btnpad btnmr">
                  Add RFP Award Letter
                </button>
                <button
                  type="button"
                  pButton
                  (click)="
                    onPoeDocumentUploadClick(
                      DocumentTypesValue.RequestForProposalDescription
                    )
                  "
                  pTooltip="Upload or View"
                  tooltipPosition="top"
                  class="ui-button-info btnpad btnmr">
                  Add RFP Description
                </button>
              }
            </div>
          </div>
        </div>

        <input type="hidden" formControlName="poeDocs" />
        <input type="hidden" formControlName="poeInvoiceDocId" />
        <p-table [value]="poeNominationRequiredDocuments">
          <ng-template #header let-columns>
            <tr>
              <th style="width: 20%">Document Name</th>
              <th style="width: 10%">Download</th>
              <th style="width: 10%">Preview</th>
              <th style="width: 15%">Upload Date</th>
              <th style="width: 15%">Type</th>
              <th style="width: 20%">Status</th>
              <th style="width: 30%">Reason</th>
            </tr>
          </ng-template>
          <ng-template #body let-rowData>
            <tr>
              <td>
                @if (rowData.filePath) {
                  <a
                    class="doc-name"
                    href="{{ rowData.filePath }}"
                    target="_blank"
                    >{{ rowData.documentName }}</a
                  >
                }
                @if (!rowData.filePath) {
                  <span>{{ rowData.documentName }}</span>
                }
              </td>
              <td>
                <span
                  class="fa fa-download ico cpointer"
                  pTooltip="Download"
                  (click)="downloadPOE(rowData)"
                  (keydown.enter)="downloadPOE(rowData)"
                  tabindex="0"
                  tooltipPosition="bottom"></span>
              </td>
              @if (
                rowData.documentName !== invoiceDocument ||
                (rowData.poeDocName === invoiceDocument &&
                  !canShowInvoicePreview(rowData.filePath))
              ) {
                <td>
                  <a
                    class="ml-2"
                    (click)="previewInvoice(rowData)"
                    (keydown.enter)="previewInvoice(rowData)"
                    tabindex="">
                    <i class="fa fa-file fa-lg" pTooltip="Preview"></i
                  ></a>
                </td>
              }
              @if (
                rowData.documentName === invoiceDocument &&
                canShowInvoicePreview(rowData.filePath)
              ) {
                <td>
                  <a
                    class="ml-2"
                    (click)="previewInvoice(rowData)"
                    (keydown.enter)="previewInvoice(rowData)"
                    tabindex="0">
                    <i class="fa fa-file fa-lg" pTooltip="Preview"></i
                  ></a>
                </td>
              }
              <td>{{ rowData.uploadDate | date: 'MM/dd/yyyy' }}</td>
              <td>
                {{ checkPoeDocumentType(rowData.documentId) }}
              </td>
              @if (rowData.documentId === DocumentTypesValue.POEDocument) {
                <td>
                  <p-select
                    appendTo="body"
                    [options]="PoeDocStatus"
                    [readonly]="isReadonlyPOESurvey"
                    [class.readonlydd]="isReadonlyPOESurvey === true"
                    #selfRef
                    formControlName="poeDOCstatusCn"
                    placeholder="--SELECT--"
                    optionLabel="poeDocStatusName"></p-select>
                </td>
              }
              @if (rowData.documentId === DocumentTypesValue.POEInvoice) {
                <td>
                  <p-select
                    appendTo="body"
                    [options]="PoeDocStatus"
                    [readonly]="isReadonlyPOESurvey"
                    [class.readonlydd]="isReadonlyPOESurvey === true"
                    formControlName="poeInvoicestatus"
                    placeholder="--SELECT--"
                    optionLabel="poeDocStatusName"></p-select>
                </td>
              }
              @if (
                rowData.documentId ===
                DocumentTypesValue.RequestForProposalAwardLetter
              ) {
                <td>
                  <p-select
                    appendTo="body"
                    [options]="PoeDocStatus"
                    [readonly]="isReadonlyPOESurvey"
                    [class.readonlydd]="isReadonlyPOESurvey === true"
                    formControlName="poeRFPAwardLetterCtrl"
                    placeholder="--SELECT--"
                    optionLabel="poeDocStatusName"></p-select>
                </td>
              }
              @if (
                rowData.documentId ===
                DocumentTypesValue.RequestForProposalDescription
              ) {
                <td>
                  <p-select
                    appendTo="body"
                    [options]="PoeDocStatus"
                    [readonly]="isReadonlyPOESurvey"
                    [class.readonlydd]="isReadonlyPOESurvey === true"
                    formControlName="poeRFPDescriptionCtrl"
                    placeholder="--SELECT--"
                    optionLabel="poeDocStatusName"></p-select>
                </td>
              }
              @if (rowData.documentId === DocumentTypesValue.SOW) {
                <td>
                  <p-select
                    appendTo="body"
                    [options]="PoeDocStatus"
                    [readonly]="isReadonlyPOESurvey"
                    [class.readonlydd]="isReadonlyPOESurvey === true"
                    formControlName="poeSecurityOfWork"
                    placeholder="--SELECT--"
                    optionLabel="poeDocStatusName"></p-select>
                </td>
              }
              <td>
                @if (rowData.documentId === DocumentTypesValue.POEDocument) {
                  <span>
                    @if (
                      formPOESurvey.controls['poeDOCstatusCn'].value
                        .poeDocStatusName === 'Rejected' &&
                      !isReadonlyPOESurvey &&
                      poeDocumentRejectionReasons
                    ) {
                      <p-multiSelect
                        appendTo="body"
                        name="poeDocRejectionList"
                        placeholder="Select reason for rejecting the invoice"
                        [maxSelectedLabels]="2"
                        [options]="poeDocumentRejectionReasons"
                        optionLabel="reason"
                        formControlName="poeDocumentRejectionReasonsCtrl"></p-multiSelect>
                    }
                  </span>
                }
                @if (rowData.documentId === DocumentTypesValue.POEInvoice) {
                  <span>
                    @if (
                      formPOESurvey.controls['poeInvoicestatus'].value
                        .poeDocStatusName === 'Rejected' &&
                      !isReadonlyPOESurvey &&
                      poeInvoiceRejectionReasons
                    ) {
                      <p-multiSelect
                        appendTo="body"
                        name="poeInvoiceRejectionReasons"
                        placeholder="Select reason for rejecting the invoice"
                        [maxSelectedLabels]="2"
                        [options]="poeInvoiceRejectionReasons"
                        optionLabel="reason"
                        formControlName="poeInvoiceRejectionReasonsCtrl"></p-multiSelect>
                    }
                  </span>
                }
                @if (
                  rowData.documentId ===
                  DocumentTypesValue.RequestForProposalAwardLetter
                ) {
                  <span>
                    @if (
                      formPOESurvey.controls['poeRFPAwardLetterCtrl'].value
                        .poeDocStatusName === 'Rejected' &&
                      !isReadonlyPOESurvey &&
                      rfpAwardLetterRejectionReasons
                    ) {
                      <p-multiSelect
                        appendTo="body"
                        name="rfpAwardLetterRejectionReasons"
                        placeholder="Select reason for rejecting the invoice"
                        [maxSelectedLabels]="2"
                        [options]="rfpAwardLetterRejectionReasons"
                        optionLabel="reason"
                        formControlName="rfpAwardLetterRejectionReasonsCtrl"></p-multiSelect>
                    }
                  </span>
                }
                @if (
                  rowData.documentId ===
                  DocumentTypesValue.RequestForProposalDescription
                ) {
                  <span>
                    @if (
                      formPOESurvey.controls['poeRFPDescriptionCtrl'].value
                        .poeDocStatusName === 'Rejected' &&
                      !isReadonlyPOESurvey &&
                      rfpDescriptionRejectionReasons
                    ) {
                      <p-multiSelect
                        appendTo="body"
                        name="rfpDescriptionRejectionReasons"
                        placeholder="Select reason for rejecting the invoice"
                        [maxSelectedLabels]="2"
                        [options]="rfpDescriptionRejectionReasons"
                        optionLabel="reason"
                        formControlName="rfpDescriptionRejectionReasonsCtrl"></p-multiSelect>
                    }
                  </span>
                }
                @if (rowData.documentId === DocumentTypesValue.SOW) {
                  <span>
                    @if (
                      formPOESurvey.controls['poeSecurityOfWork'].value
                        .poeDocStatusName === 'Rejected' &&
                      !isReadonlyPOESurvey &&
                      sowDocRejectionReasons
                    ) {
                      <p-multiSelect
                        appendTo="body"
                        name="sowDocRejectionReasons"
                        placeholder="Select reason for rejecting the invoice"
                        [maxSelectedLabels]="2"
                        [options]="sowDocRejectionReasons"
                        optionLabel="reason"
                        formControlName="sowDocRejectionReasonsCtrl"></p-multiSelect>
                    }
                  </span>
                }
                @if (rowData.reasons && isReadonlyPOESurvey) {
                  <span>{{ getReasons(rowData.reasons) }}</span>
                }
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    }
    @if (poeNominationDocuments) {
      <div class="edittablebdr">
        <div class="ui-g">
          <div class="ui-g-12 ui-md-12 ui-lg-12">
            <div class="hdbl">Saved Documents</div>
          </div>
        </div>

        <p-table
          [value]="poeNominationDocuments.poeDocumentsHistory"
          [paginator]="true"
          [rows]="historyTableRow"
          [alwaysShowPaginator]="false">
          <ng-template #header let-columns>
            <tr>
              <th style="width: 25%">Document Name</th>
              <th style="width: 15%">Preview</th>
              <th style="width: 15%">Upload Date</th>
              <th style="width: 15%">Type</th>
              <th style="width: 15%">Status</th>
              <th style="width: 35%">Reason</th>
            </tr>
          </ng-template>
          <ng-template #body let-rowData>
            <tr>
              <td>
                @if (rowData.filePath) {
                  <a href="{{ rowData.filePath }}" target="_blank">{{
                    rowData.fileName
                  }}</a>
                }
                @if (!rowData.filePath) {
                  <span>{{ rowData.documentName }}</span>
                }
              </td>
              <td>
                @if (rowData.filePath && !isRFPDoc(rowData.documentId)) {
                  <a
                    class="ml-2"
                    (click)="previewHistoryDocument(rowData)"
                    (keydown.enter)="previewHistoryDocument(rowData)"
                    tabindex="0">
                    <i class="fa fa-file fa-lg" pTooltip="Preview"></i
                  ></a>
                }
              </td>
              <td>{{ rowData.uploadDate | date: 'MM/dd/yyyy' }}</td>
              <td>{{ checkPoeDocumentType(rowData.documentId) }}</td>
              <td>{{ rowData.status }}</td>
              <td>
                @if (rowData.reasons) {
                  <span>
                    {{ getReasons(rowData.reasons) }}
                  </span>
                }
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    }
  </div>
</form>

<p-dialog
  [(visible)]="loadUploadDialog"
  [contentStyle]="{
    'max-height': '550px',
    'overflow-y': 'auto',
    width: '700px',
    'z-index': '10027px'
  }"
  [closable]="false"
  [draggable]="false"
  showEffect="fade"
  [modal]="false">
  <ng-template #header>
    <div class="ui-g-11">
      {{ fileUploadHeader }}
    </div>
    <div
      class="ui-g-1 closesidebar diaclnav"
      (click)="cancelUploadDocument()"
      (keydown.enter)="cancelUploadDocument()"
      tabindex="0">
      <i class="mdl2-cancel cpointer" style="float: right; color: #212121"></i>
    </div>
  </ng-template>

  <div class="tolFile">
    <p>
      File size must be less than 10 MB.
      <span>Acceptable file types: doc, pdf, image or pptx</span>
    </p>
  </div>
  <div class="tolFile">
    <p><b>Note: </b>Drag and Drop/Browse files will be Uploaded to Server.</p>
  </div>
  @for (message of umsgs; track message) {
    <p-message [life]="3000" [text]="message.detail"></p-message>
  }
  <div
    class="uploadfilecontainer"
    appDragDrop
    (onFileDropped)="uploadFile($event)">
    <div><i class="fa fa-cloud-upload fa-lg"></i></div>
    Drag and drop files here or
    <a
      (click)="fileInputUpload.click()"
      (keyup.enter)="fileInputUpload.click()"
      tabindex="0"
      >Browse</a
    >
    <input hidden type="file" #fileInputUpload (change)="uploadFile($event)" />
  </div>
  @if (filesUpload) {
    <div class="tolFile">
      <p>
        Total Number of File in Uploading:
        {{ filesUpload.length }}
      </p>
    </div>
  }
  <div class="files-list listtable">
    <table>
      <tr *ngFor="let file of filesUpload; let i = index">
        <td>{{ file.fileName }}</td>
        <td class="tdwidth">
          @if (fileUploadSpinners[i] !== true) {
            <i class="fa fa-check-circle"></i>
          }
          @if (fileUploadSpinners[i] === true) {
            <i class="fa fa-spinner fa-spin"></i>
          }
        </td>
        <td class="tdwidth">
          @if (fileUploadSpinners[i] !== true) {
            <span>{{ formatBytes(file?.size, 0) }}</span>
          }
          @if (fileUploadSpinners[i] === true) {
            <i class="fa fa-spinner fa-spin"></i>
          }
        </td>
      </tr>
    </table>
  </div>
  @if (showUploadedFiles) {
    <div class="tolFile">
      <p>Files in List</p>
    </div>
    <div class="files-list listtable">
      <table>
        <thead>
          <tr>
            <th width="7">File Name</th>
            <th class="tdwidth">Preview</th>
            <th class="tdwidth">Download</th>
            <th class="tdwidth">Delete</th>
          </tr>
        </thead>
        <tr *ngFor="let file of customerAck; let i = index">
          <td>
            @if (downloadSpin[i] === true) {
              <img
                src="../../../assets/images/download.gif"
                width="7"
                alt="Downloading" />
            }
            {{ file.fileName }}
          </td>
          <td class="tdwidth">
            @if (canShowPreviewButton(file)) {
              <a
                (click)="previewFile(i)"
                (keyup.enter)="previewFile(i)"
                tabindex="0">
                <i
                  class="fa fa-file fa-lg"
                  aria-hidden="true"
                  pTooltip="Preview"
                  tooltipPosition="bottom"></i>
              </a>
            }
          </td>
          <td class="tdwidth">
            <a
              (click)="downloadFile(i)"
              (keyup.enter)="downloadFile(i)"
              tabindex="0">
              <i
                class="fa fa-download fa-lg"
                aria-hidden="true"
                pTooltip="Download"
                tooltipPosition="bottom"></i>
            </a>
          </td>
          <td class="tdwidth">
            <a
              (click)="deleteAttachment(i)"
              (keydown.enter)="deleteAttachment(i)"
              tabindex="0">
              <i
                class="fa fa-remove fa-lg"
                aria-hidden="true"
                pTooltip="Delete"
                tooltipPosition="bottom"></i>
            </a>
          </td>
        </tr>
      </table>
    </div>
  }
  <br />
  <div style="text-align: right">
    <button
      type="submit"
      pButton
      (click)="submitCustomerAckFile()"
      class="flat btnmr">
      Submit
    </button>
    <button
      type="button"
      pButton
      (click)="cancelUploadDocument()"
      class="ui-button-secondary flat">
      Cancel
    </button>
  </div>
</p-dialog>

@if (canShowPreviewModel) {
  <app-engagement-preview
    (OnPoeDocumentReview)="reviewPoeDocument($event)"
    (OnInvoiceReview)="reviewPoeInvoice($event)"
    [engagementPreviewInput]="engagementPreviewInput"
    (closePreviewModal)="closePreview()"></app-engagement-preview>
}
